// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Modal_wrap__9jqZI","big":"Modal_big__NenCO","open":"Modal_open__uTMSL","inner":"Modal_inner__QKMph","content":"Modal_content__h9my9","close":"Modal_close__dxiZj"};